module.exports = __webpack_public_path__ + "static/media/delete_outline.db83002b.svg";